import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

function Button({
  type,
  children,
  color,
  to,
  disabled,
  onClick,
  className,
  ...rest
}, ref) {
  const buttonClass = classNames('btn', { [`btn--${color}`]: color }, className);

  return (
    to ? (
      <Link
        to={to}
        ref={ref}
        className={buttonClass}
        onClick={onClick}
      >
        {children}
      </Link>
    ) : (
      // eslint-disable-next-line react/button-has-type
      <button
        {...rest}
        ref={ref}
        className={buttonClass}
        type={type}
        disabled={disabled}
        onClick={onClick}
      >
        { children }
      </button>
    )
  );
}

export default React.forwardRef(Button);

Button.defaultProps = {
  to: null,
  onClick: () => {},
  type: 'button',
  color: null,
  disabled: false,
  className: '',
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['button', 'submit']),
  color: PropTypes.oneOf(['yellow', 'red', 'blue']),
  to: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};
